







import {
  Component,
  Vue,
} from 'vue-property-decorator';

import { ProductVariant } from '@/models';

import ProductFeature from './ProductFeature';

@Component
export default class PartialStateBuyboxFeature extends ProductFeature { }

